import { fromJS } from 'immutable';
import { basicSort } from '../../../util/sortUtils';
import { sort } from '../data/earthquakeReduxConstants';

export const EARTHQUAKE_SEARCH_REQUEST = 'EARTHQUAKE_SEARCH_REQUEST';
export const EARTHQUAKE_SEARCH_SUCCESS = 'EARTHQUAKE_SEARCH_SUCCESS';
export const EARTHQUAKE_SEARCH_FAILURE = 'EARTHQUAKE_SEARCH_FAILURE';

export const EARTHQUAKE_SEARCH_CLEAR = 'EARTHQUAKE_SEARCH_CLEAR';
export const EARTHQUAKE_SEARCH_CLEAR_REDIRECT = 'EARTHQUAKE_SEARCH_CLEAR_REDIRECT';

export const EARTHQUAKE_SEARCH_REGION_REQUEST = 'EARTHQUAKE_SEARCH_REGION_REQUEST';
export const EARTHQUAKE_SEARCH_REGION_SUCCESS = 'EARTHQUAKE_SEARCH_REGION_SUCCESS';
export const EARTHQUAKE_SEARCH_REGION_FAILURE = 'EARTHQUAKE_SEARCH_REGION_FAILURE';

export const EARTHQUAKE_SEARCH_COUNTRY_REQUEST = 'EARTHQUAKE_SEARCH_COUNTRY_REQUEST';
export const EARTHQUAKE_SEARCH_COUNTRY_SUCCESS = 'EARTHQUAKE_SEARCH_COUNTRY_SUCCESS';
export const EARTHQUAKE_SEARCH_COUNTRY_FAILURE = 'EARTHQUAKE_SEARCH_COUNTRY_FAILURE';

export const EARTHQUAKE_SEARCH_AREA_REQUEST = 'EARTHQUAKE_SEARCH_AREA_REQUEST';
export const EARTHQUAKE_SEARCH_AREA_SUCCESS = 'EARTHQUAKE_SEARCH_AREA_SUCCESS';
export const EARTHQUAKE_SEARCH_AREA_FAILURE = 'EARTHQUAKE_SEARCH_AREA_FAILURE';

export const EARTHQUAKE_DATA_SORT = 'EARTHQUAKE_DATA_SORT';

const initialState = fromJS({
  searching: false,
  fetched: false,
  earthquakes: [],
  queryParameters: {},
  searchRedirect: false,

  fetchedRegions: false,
  regions: [],
  fetchedCountries: false,
  countries: [],
  fetchingAreas: false,
  areas: [],

  sort,
});

// default param first is the redux convention https://redux.js.org/tutorials/fundamentals/part-3-state-actions-reducers
// eslint-disable-next-line default-param-last
export const earthquakeSearchReducer = (state = initialState, action) => {
  switch (action.type) {
    case EARTHQUAKE_SEARCH_CLEAR_REDIRECT:
      return state.set('searchRedirect', false);
    case EARTHQUAKE_SEARCH_CLEAR:
      return initialState.merge(fromJS({
        sort: state.get('sort'),
      }));

    case EARTHQUAKE_DATA_SORT:
      return state.merge(fromJS({
        earthquakes: basicSort(action.sort, state.get('earthquakes')),
        sort: action.sort,
      }));

    case EARTHQUAKE_SEARCH_REQUEST:
      return state.merge(fromJS({
        searching: true,
        fetched: false,
        queryParameters: action.queryParameters,
        searchRedirect: Boolean(action.searchRedirect),
      }));
    case EARTHQUAKE_SEARCH_SUCCESS:
      return state.merge(fromJS({
        searching: false,
        fetched: true,
        earthquakes: basicSort(state.get('sort'), fromJS(action.response.items)),
      }));
    case EARTHQUAKE_SEARCH_FAILURE:
      return state.merge(fromJS({
        searching: false,
        fetched: true,
      }));

    case EARTHQUAKE_SEARCH_REGION_REQUEST:
      return state.merge(fromJS({
        fetchedRegions: false,
      }));
    case EARTHQUAKE_SEARCH_REGION_SUCCESS:
      return state.merge(fromJS({
        fetchedRegions: true,
        regions: action.response.items,
      }));
    case EARTHQUAKE_SEARCH_REGION_FAILURE:
      return state.merge(fromJS({
        fetchedRegions: true,
      }));

    case EARTHQUAKE_SEARCH_COUNTRY_REQUEST:
      return state.merge(fromJS({
        fetchedCountries: false,
      }));
    case EARTHQUAKE_SEARCH_COUNTRY_SUCCESS:
      return state.merge(fromJS({
        fetchedCountries: true,
        countries: action.response.items,
      }));
    case EARTHQUAKE_SEARCH_COUNTRY_FAILURE:
      return state.merge(fromJS({
        fetchedCountries: true,
      }));

    case EARTHQUAKE_SEARCH_AREA_REQUEST:
      return state.merge(fromJS({
        fetchingAreas: true,
      }));
    case EARTHQUAKE_SEARCH_AREA_SUCCESS:
      return state.merge(fromJS({
        fetchingAreas: false,
        areas: action.response.items,
      }));
    case EARTHQUAKE_SEARCH_AREA_FAILURE:
      return state.merge(fromJS({
        fetchingAreas: false,
        areas: initialState.get('areas'),
      }));

    default:
      return state;
  }
};
